import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatFileUrl } from "../../../utils/api";
import { STATIC_EVENTS } from "../staticEventsData";

export default function Events() {
  const navigate = useNavigate();
  const [dynamicEvents, setDynamicEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Scroll to the top when the route changes
    window.scrollTo(0, 0);
    fetchGalleryItems();
  }, []);

  const staticEvents = STATIC_EVENTS;

  const fetchGalleryItems = async () => {
    try {
      const res = await api.get("/gallery");
      setDynamicEvents(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Failed to fetch gallery items", err);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (id, isStatic) => {
    if (isStatic) {
      navigate(`/events-details/${id.replace('static-', '')}`);
    } else {
      navigate(`/events-details/${id}`);
    }
  };

  if (loading) {
    return <div className="py-20 text-center text-neutral-500">Loading gallery...</div>;
  }

  // Combine static events and dynamic events from database
  const allEvents = [...dynamicEvents, ...staticEvents];

  return (
    <>
      <div className="relative">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 py-5">
          {allEvents.map((event) => (
            <div
              key={event._id}
              onClick={() => handleChange(event._id, event.isStatic)}
              className="bg-white hover:scale-[0.95] z-40 cursor-pointer transition-all shadow-2xl rounded-lg overflow-hidden border border-gray-200"
            >
              <img
                src={event.isStatic ? event.imageUrl : formatFileUrl(event.imageUrl)}
                alt={event.title}
                className="w-full h-52 object-cover"
                loading="lazy"
              />
              <div className="p-4">
                <h3 className="text-lg font-semibold text-gray-800 text-start font-AndoraModernSerif">
                  {event.title}
                </h3>
                {event.description && (
                  <p className="text-gray-600 mt-2 text-sm text-start">
                    {event.description}
                  </p>
                )}
              </div>
            </div>
          ))}
          {allEvents.length === 0 && (
            <div className="col-span-full text-center py-12 text-neutral-400">
              No gallery items found. Check back later!
            </div>
          )}
        </div>
      </div>
    </>
  );
}
